import React__default from 'react';
import '@walmart-web/livingdesign-components/index.esm.css';
import { Body } from '@walmart-web/livingdesign-components';
import '../Alert/Alert.js';
import { Button } from '../Button/Button.js';
import '../Button/ButtonGroup.js';
import '../Radio/Radio.js';
import '../Tag/Tag.js';
import { Checkbox } from '../Checkbox/Checkbox.js';
import '../Chip/Chip.js';
import classNames from '../../node_modules/classnames/index.js';
import { IconButton } from '../IconButton/IconButton.js';
import { Check, ChevronRight, CaretDown } from '@livingdesign/icons';
import '@livingdesign/tokens/dist/js/light/regular/components/Form';
import '../TextField/TextField.js';
import '../TabNavigation/TabNavigation.js';
import '../TabNavigation/TabNavigationItem.js';
import '../Modal/Modal.js';
import '@livingdesign/tokens/dist/js/light/regular/components/ErrorMessage';
import '../SearchBox/SearchBox.js';
import '../AutoComplete/AutoComplete.js';
import '../TextArea/TextArea.js';
import '../ProgressIndicator/ProgressIndicator.js';
import '../Panel/Panel.js';
import '../Calendar/context.js';
import 'dayjs';
import '../Calendar/RenderDays.js';
import '../Calendar/RenderWeeks.js';
import '../Calendar/locale/wmLocale.js';
import '../Calendar/locale/stdLocale.js';
import '../utility/constants.js';
import '@react-aria/ssr';
import '../CardActionArea/CardActionArea.js';
import './HierarchySelector.js';
import '../Pagination/Pagination.js';
import '../DisplayTag/DisplayTag.js';
import '../PageHeader/PageHeader.js';
import '../Table/Table.js';
import '../Tooltip/Tooltip.js';
import '../ValueChange/ValueChange.js';
import styles from './HierarchySelector.module.scss.js';

var HierarchyList = function HierarchyList(props) {
  var _props$header = props.header,
    header = _props$header === void 0 ? '' : _props$header,
    levelDataMaps = props.levelDataMaps,
    _props$level = props.level,
    level = _props$level === void 0 ? -1 : _props$level,
    onSelectAll = props.onSelectAll,
    onExpand = props.onExpand,
    onSelectionChange = props.onSelectionChange,
    onSubHierarchyExpandCollapse = props.onSubHierarchyExpandCollapse,
    disabled = props.disabled,
    singleSelect = props.singleSelect;
  var handleOnChange = function handleOnChange(event) {
    var data = event.target.id.split('~');
    onSelectionChange(Number(data[0]), data[1], event.target.checked);
  };
  var handleOnExpand = function handleOnExpand(itemLevel, itemNestedId) {
    var _levelDataMaps$itemLe;
    var currentItem = (_levelDataMaps$itemLe = levelDataMaps[itemLevel]) === null || _levelDataMaps$itemLe === void 0 ? void 0 : _levelDataMaps$itemLe.get(itemNestedId);
    if (currentItem && !currentItem.disabled) {
      onExpand(itemLevel, itemNestedId);
    }
  };
  var handleSelectAll = function handleSelectAll(event) {
    onSelectAll(Number(event.target.id.replace('level', '')), event.target.checked);
  };
  var renderLevelHeader = function renderLevelHeader() {
    var _levelDataMaps$level$, _levelDataMaps$level, _levelDataMaps$values, _levelDataMaps;
    var curLevelItems = level < 1 ? Array.from((_levelDataMaps$level$ = (_levelDataMaps$level = levelDataMaps[level]) === null || _levelDataMaps$level === void 0 ? void 0 : _levelDataMaps$level.values()) !== null && _levelDataMaps$level$ !== void 0 ? _levelDataMaps$level$ : []) : Array.from((_levelDataMaps$values = (_levelDataMaps = levelDataMaps[level - 1]) === null || _levelDataMaps === void 0 ? void 0 : _levelDataMaps.values()) !== null && _levelDataMaps$values !== void 0 ? _levelDataMaps$values : []).filter(function (item) {
      return item.expanded;
    }).reduce(function (childItems, curParentItem) {
      return childItems.concat(curParentItem.subHierarchy);
    }, []);
    if (curLevelItems.length < 1) {
      return null;
    }
    var curLevelSelectedItems = curLevelItems.filter(function (item) {
      return item.checked;
    });
    return /*#__PURE__*/React__default.createElement("div", {
      className: styles.levelHeaderStyled
    }, /*#__PURE__*/React__default.createElement("span", {
      className: styles.selectAllCheckboxWrapper,
      "data-testid": "Hierarchy_CompleteLevelSelector_".concat(level)
    }, !singleSelect ? /*#__PURE__*/React__default.createElement(Checkbox, {
      checked: curLevelSelectedItems.length > 0,
      indeterminate: curLevelSelectedItems.length > 0 && curLevelSelectedItems.length < curLevelItems.length,
      id: "level".concat(level),
      label: "".concat(header, " (").concat(curLevelSelectedItems.length, " of ").concat(curLevelItems.length, ")"),
      onChange: handleSelectAll,
      disabled: disabled,
      "aria-disabled": disabled,
      tabIndex: 0
    }) : /*#__PURE__*/React__default.createElement(Body, null, header)));
  };
  var renderSelectionItem = function renderSelectionItem(item) {
    var header = "".concat(item.id, " ").concat(item.name).toLowerCase();
    return /*#__PURE__*/React__default.createElement("div", {
      className: classNames(styles.selectionListItem, item.expanded && singleSelect ? styles.singleSelectionListItem : null),
      key: item.nestedId,
      id: item.nestedId
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles.listItemLeft
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles.checkboxWrapper
    }, !singleSelect ? /*#__PURE__*/React__default.createElement("span", {
      "data-testid": "Hierarchy_CheckboxSelector_".concat(item.level, "~").concat(item.nestedId)
    }, /*#__PURE__*/React__default.createElement(Checkbox, {
      checked: item.checked,
      disabled: disabled || item.disabled,
      indeterminate: item.indeterminate,
      value: "".concat(item.nestedId, "-").concat(item.name),
      a11yLabelledBy: "".concat(item.level, "~").concat(item.nestedId),
      id: "".concat(item.level, "~").concat(item.nestedId),
      onChange: handleOnChange,
      "aria-disabled": disabled
    })) : null, item.subHierarchy.length < 1 && singleSelect && !disabled ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", null, item.checked ? /*#__PURE__*/React__default.createElement(Check, null) : null, /*#__PURE__*/React__default.createElement(Button, {
      variant: "tertiary",
      UNSAFE_className: styles.singleSelectItem,
      onClick: function onClick() {
        return onSelectionChange(Number(item.level), item.nestedId, true);
      },
      tabIndex: 0
    }, header))) : /*#__PURE__*/React__default.createElement(Body, {
      UNSAFE_className: styles.listItemText
    }, /*#__PURE__*/React__default.createElement("span", {
      title: "".concat(item.id, " ").concat(item.name)
    }, header, " "))), item.subHierarchy.length < 1 || disabled ? null : /*#__PURE__*/React__default.createElement(IconButton, {
      UNSAFE_className: styles.iconButton,
      "data-testid": "Hierarchy_Expand_".concat(item.level, "~").concat(item.nestedId),
      id: "expand-".concat(item.nestedId),
      a11yLabel: "expand-".concat(item.nestedId),
      onClick: function onClick() {
        return handleOnExpand(item.level, item.nestedId);
      },
      tabIndex: 0
    }, /*#__PURE__*/React__default.createElement(ChevronRight, null))));
  };
  var renderLevel0 = function renderLevel0() {
    var _levelDataMaps$level2;
    var level0Items = Array.from(((_levelDataMaps$level2 = levelDataMaps[level]) === null || _levelDataMaps$level2 === void 0 ? void 0 : _levelDataMaps$level2.values()) || []);
    return /*#__PURE__*/React__default.createElement("div", {
      className: styles.itemsContainer,
      "data-testid": "Hierarchy_ListContainer"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles.itemList
    }, level0Items.map(function (item) {
      return renderSelectionItem(item);
    })));
  };
  var getSubHierarchyHeader = function getSubHierarchyHeader(parentItem) {
    if (parentItem.subHierarchy.length < 1) {
      return '';
    }
    return " (".concat(parentItem.subHierarchy.filter(function (sh) {
      return sh.checked;
    }).length, " of ").concat(parentItem.subHierarchy.length, ")");
  };
  var handleSubHierarchyExpandCollapse = function handleSubHierarchyExpandCollapse(parentLevel, parentNestedId) {
    onSubHierarchyExpandCollapse(parentLevel, parentNestedId);
  };
  var _onKeyDown = function onKeyDown(event, onClick) {
    if (event.key === 'Enter' || event.key === ' ') {
      onClick();
    }
  };
  var renderSubHierarchyHeader = function renderSubHierarchyHeader(parentItem) {
    var header = "".concat(parentItem === null || parentItem === void 0 ? void 0 : parentItem.id, " ").concat(parentItem === null || parentItem === void 0 ? void 0 : parentItem.name).toLowerCase();
    var onClick = function onClick() {
      return handleSubHierarchyExpandCollapse(parentItem.level, parentItem.nestedId);
    };
    return /*#__PURE__*/React__default.createElement("div", {
      className: classNames(styles.subHierarchy, styles.subHierachyList),
      "data-value": parentItem.nestedId,
      id: "collapse-".concat(parentItem.nestedId),
      role: "button",
      onClick: onClick,
      tabIndex: 0,
      onKeyDown: function onKeyDown(event) {
        return _onKeyDown(event, onClick);
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles.subHeaderContainer
    }, /*#__PURE__*/React__default.createElement(Body, null, /*#__PURE__*/React__default.createElement("span", {
      className: styles.subHeaderText
    }, header), /*#__PURE__*/React__default.createElement("span", {
      className: styles.subHeaderCal
    }, getSubHierarchyHeader(parentItem)))), parentItem.showChildren ? /*#__PURE__*/React__default.createElement(CaretDown, {
      size: "small"
    }) : /*#__PURE__*/React__default.createElement(ChevronRight, {
      size: "small"
    }));
  };
  var renderLevel0Plus = function renderLevel0Plus() {
    var _levelDataMaps$values2, _levelDataMaps2;
    var parentLevelItems = Array.from((_levelDataMaps$values2 = (_levelDataMaps2 = levelDataMaps[level - 1]) === null || _levelDataMaps2 === void 0 ? void 0 : _levelDataMaps2.values()) !== null && _levelDataMaps$values2 !== void 0 ? _levelDataMaps$values2 : []).filter(function (pItem) {
      return pItem.subHierarchy.length > 0 && pItem.expanded;
    });
    if (parentLevelItems.length < 1) return null;
    return /*#__PURE__*/React__default.createElement("div", {
      className: styles.itemsContainer
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles.itemList
    }, parentLevelItems.map(function (pItem) {
      return /*#__PURE__*/React__default.createElement("div", {
        key: pItem.nestedId
      }, !singleSelect ? renderSubHierarchyHeader(pItem) : null, /*#__PURE__*/React__default.createElement("div", {
        className: pItem.showChildren ? styles.itemsCollapseShow : styles.itemsCollapseHide
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles.selectionItemList
      }, pItem.subHierarchy.map(renderSelectionItem))));
    })));
  };
  var renderList = function renderList() {
    return /*#__PURE__*/React__default.createElement("div", {
      className: classNames(styles.listContainer, styles.listColumn)
    }, renderLevelHeader(), level === 0 ? renderLevel0() : renderLevel0Plus());
  };
  return !levelDataMaps || !levelDataMaps[level] ? /*#__PURE__*/React__default.createElement("div", null, "Loading...") : renderList();
};

export { HierarchyList as default };
